import router from '../../../router'
import NavigationBar from '../../../components/navigation-bar/NavigationBar'
import TabBar from '../../../components/tab-bar/TabBar'
import InputButton from '../../../components/input-button/InputButton'
import InputText from '../../../components/input-text/InputText'
import {BookingOption, BookingOptionTypeDropDown, BookingOptionType, BookingService} from "@/services/booking.service";
import SettingsHeader from "@/components/settings-header/SettingsHeader";
import InputCheckbox from "@/components/input-checkbox/InputCheckbox";
import InputDropdown from "@/components/input-dropdown/InputDropdown";
import {Constants} from "@/constants";
import {SortedTable, SortLink} from "vue-sorted-table";


export default {
    name: "Options",
    components: {
        NavigationBar,
        TabBar,
        InputButton,
        InputText,
        InputCheckbox,
        SettingsHeader,
        InputDropdown,
        SortedTable,
        SortLink,
    },

    data() {
        return {
            option: new BookingOption(),
            edit: true,
            types: [
                new BookingOptionTypeDropDown(0, BookingOptionType.Boolean),
                new BookingOptionTypeDropDown(1, BookingOptionType.Numbers),
                new BookingOptionTypeDropDown(2, BookingOptionType.Text),
                new BookingOptionTypeDropDown(3, BookingOptionType.Date),
                new BookingOptionTypeDropDown(4, BookingOptionType.Select)
            ],
            locationId: undefined,
            selectOptions: [],
            enteredOption: undefined
        }
    },

    computed: {
        isAllowed() {
            return !(this.edit && !this.option.pattern);
        },
    },

    mounted() {
        this.option.locationId = this.$route.params.locationId
        if (this.$route.params.id == "undefined") {
            this.edit = false
        } else {
            this.getOption(this.$route.params.id)
        }
    },

    methods : {

        getOption: async function(id) {
            try {
                const option = await BookingService.getBookingOptionById(id)
                this.handleOptionResponse(option)
            }catch(error) {
            }
        },

        handleOptionResponse(option) {
            this.option = new BookingOption(option)
            this.selectOptions = this.option.options ?? []
        },

        doSave: async function() {
            if (this.option.name != undefined) {
                try {
                    this.option.options = this.selectOptions.length > 0 ? this.selectOptions : undefined
                    if (!this.edit) {
                        let response = await BookingService.createBookingOption(this.option)
                        this.handleMutateBookingOptionResponse(response, "The booking option has successfully been created")
                    } else {
                        let response = await BookingService.editBookingOption(this.option)
                        this.handleMutateBookingOptionResponse(response, "The booking option has successfully been updated")
                    }
                } catch (error) {
                    this.handleMutateBookingOptionFailureResponse(error.errorCode, error.message)
                }
            } else {
                for (const ref in this.$refs) {
                    if (this.$refs[ref] != undefined) {
                        this.$refs[ref].checkForError()
                    }
                }
            }
        },

        doCancel() {
            router.push(`/settings/options`)
        },

        toggleUsedForVerification() {
            this.option.usedForVerification = !this.option.usedForVerification
        },

        toggleMandatory() {
            this.option.mandatory = !this.option.mandatory
        },

        toggleArrivalDisplay() {
            this.option.usedForArrivalsDisplay = !this.option.usedForArrivalsDisplay
        },

        toggleVisitsDisplay() {
            this.option.usedForVisitsDisplay = !this.option.usedForVisitsDisplay
        },

        toggleGosReference () {
            this.option.usedForGosReference = !this.option.usedForGosReference
        },

        toggleIsGeneratedDisplay() {
            if (!this.edit) {
                if (!this.option.isGenerated) { // creating new and toggle on fill in pattern
                    this.option.pattern = "^[0-9]{6}$"
                }
                else { // creating new and toggling off
                    this.option.pattern = ""
                }
                this.option.isGenerated = !this.option.isGenerated;
            } else {
                this.option.isGenerated = !this.option.isGenerated;
            }
        },
        toggleIsForSuperUserDisplay() {
            this.option.isForSuperUser = !this.option.isForSuperUser;
        },
        changeOptionType(id) {
            if (this.types[id].value !== this.option.type) {
                this.option.type = this.types[id].value;
                this.option.isGenerated = false;
            }
        },

        handleMutateBookingOptionResponse(response, message) {
            this.$store.dispatch(Constants.STORE_ACTION_CREATE_ALERT, {code: response.status, message: message })
            router.push(`/settings/options`)
        },
        handleMutateBookingOptionFailureResponse(code, message) {
            this.$store.dispatch(Constants.STORE_ACTION_CREATE_ALERT, {code: code, message: message.errorAtEntry })
        },

        addOption() {
            this.selectOptions.push(this.enteredOption)
            this.clearOption()
        },

        removeOption(option) {
            this.selectOptions = this.selectOptions.filter(o => o != option)
        },

        clearOption() {
            this.enteredOption = undefined
        }
    }
}
